export default __webpack_public_path__ + "static/media/LOGOSCI.50a6d02b.png";